import React, { useState, useEffect } from 'react';
import arrowImage from '../../assets/arrow.png';

import styles from './ScrollToTop.module.css'

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <>
      <div
        id="scrollToTop"
        onClick={scrollToTop}
        style={{ display: isVisible ? 'block' : 'none' }}
        className={styles.scrollToTop}
      >
        <img src={arrowImage} alt="Scroll to top" />
      </div>
    </>
  );
};

export default ScrollToTop;